
<app-header></app-header>

<div class="main-wrapper" [ngClass]="{
    'main-chat-blk': page === 'account'
  }">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>